/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_404_TitleInputs */

const en_mk_404_title = /** @type {(inputs: Mk_404_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This comparison page doesn't exist yet`)
};

const id_mk_404_title = /** @type {(inputs: Mk_404_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Halaman banding ini belum ada`)
};

/**
* | output |
* | --- |
* | "This comparison page doesn't exist yet" |
*
* @param {Mk_404_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_404_title = /** @type {((inputs?: Mk_404_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_404_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_404_title(inputs)
	return en_mk_404_title(inputs)
});